"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const StringResource_1 = require("../nls/StringResource");
const utils_1 = require("../utils");
const COMPONENT_NAME = 'OverflowMenu';
const DISPLAY_NAME = (0, utils_1.getDisplayName)(COMPONENT_NAME);
const DEFAULT_TID = (0, utils_1.getDefaultTid)(COMPONENT_NAME);
const iconDescription = StringResource_1.stringResource.get('overflowMenuIconDesc');
const OverflowMenu = react_1.default.forwardRef((props, ref) => {
    const componentProps = Object.assign(Object.assign({ 'data-tid': DEFAULT_TID, iconDescription }, (ref && { ref })), props);
    return react_1.default.createElement(carbon_components_react_1.OverflowMenu, Object.assign({}, componentProps));
});
OverflowMenu.propTypes = {
    'data-tid': prop_types_1.default.string,
};
OverflowMenu.displayName = DISPLAY_NAME;
exports.default = OverflowMenu;
